import { Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { SearchKeyFilter } from '../../app/AppUtils';
import { fetchActivities } from '../activity/activitySlice';
import BackButton from '../subcomponents/BackButton';
import ContentLoader from '../subcomponents/ContentLoader';
import FilterButton from '../subcomponents/FilterButton';
import FilterSidebar from '../subcomponents/FilterSidebar';
import PageLayout from '../subcomponents/PageLayout';
import FavoriteCard from './FavoriteCard';
import FavoritesCheckMessage from './FavoritesCheckMessage';

export default function FavoritesPage() {
    const dispatch = useDispatch();

    const { activities, scrollPosition } = useSelector((state) => state.activity);
    const { favoriteAdd, favoriteRemove } = useSelector((state) => state.favorites);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { activeDepartment, departmentThemesStatus } = useSelector((state) => state.settings.theme);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { student } = useSelector((state) => state.student);

    const [filter, setFilter] = useState("");
    const [onlyFree, setOnlyFree] = useState(false);

    useEffect(() => {
        if (student !== null) {
            if (siomSettings.useMultipleDepartments) {
                if (activeDepartment !== null) {
                    dispatch(fetchActivities(activeDepartment[0].id));
                }
            } else {
                dispatch(fetchActivities(null));
            }
        }
    }, [dispatch, student, favoriteAdd.status, favoriteRemove.status, departmentThemesStatus, activeDepartment, siomSettings])

    useEffect(() => {
        if (activities.status === "success") {
            window.scrollTo(0, parseInt(scrollPosition))
        }
    }, [activities.status, scrollPosition])

    const handleChange = () => {
        setOnlyFree(!onlyFree);
    };

    const FilterFragment = () => {
        return (
            <FormGroup>
                <FormControlLabel control={<Checkbox checked={onlyFree} onChange={handleChange} />} label={`${resourceFinal[appLanguage].messages.FILTER_ONLY_FREE}`} />
            </FormGroup>
        );
    };

    const handleFilterResult = (item) => {
        return SearchKeyFilter(item, ["name", "number"], filter) && (onlyFree ? item.cost === 0 : item.cost >= 0);
    }

    return (
        <PageLayout
            title={`${resourceFinal[appLanguage].words.FAVORITES}`}
            titleLower={`${resourceFinal[appLanguage].words.MANAGE}`}
            content={
                <ContentLoader
                    successCondition={activities.status === "success"}
                    errorCondition={activities.status === "failed"}
                    content={
                        <>
                            <FavoritesCheckMessage />
                            <Grid container spacing={{ xs: 1, md: 2 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                                {activities.status === "success" ?
                                    activities.data.filter(handleFilterResult).length > 0 ? activities.data.filter(handleFilterResult).map((item) =>
                                        <Grid key={item.id}>
                                            <FavoriteCard favoritePage={false} itemId={item.id} activityId={item.id} name={item.name} imageUrl={item.imageUrl} userFavorite={item.userFavorite} />
                                        </Grid>
                                    ) : <Grid size={{ xs: "grow" }}><Typography variant="h6" textAlign="center">{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</Typography></Grid> : ""}
                                {activities.status === "success" ? Object.keys(activities.data).length === 0 ? <Typography variant="h6" sx={{ mt: 10 }}>{resourceFinal[appLanguage].messages.NO_CURRENT_CLINICS}</Typography> : "" : ""}
                            </Grid>
                        </>
                    }
                />
            } contentLeft={
                <FilterSidebar enableSearch searchFilter={filter} searchFilterSet={setFilter} filters={<FilterFragment />} />
            } contentBottom={
                <FilterButton filters={<FilterFragment />} />
            } contentRight={
                <BackButton desktop />
            }
            bottomBar
            enableSearch
            searchFilter={filter}
            searchFilterSet={setFilter}
            disableHeaderBackground
            disableContentBackground
        />
    );
}
